import axios from 'axios'
import { message } from 'antd'

const $axios = axios.create({
    baseURL: process.env.REACT_APP_UPLOAD_URL
})

// 请求拦截
$axios.interceptors.request.use(config => {
    const formData = new FormData();
    formData.append('path', 'cms/banner');
    formData.append('file', config.data);
    config.data = formData
    config.headers = {
        ...config.headers,
        token: process.env.REACT_APP_UPLOAD_TOKEN
    }
    return config
}, error => {
    console.log('request error:\n', error)
    return Promise.reject(error)
})

// 响应拦截
$axios.interceptors.response.use(function (response) {
    const code = response.data.code
    // token no work
    if (code !== 200) {
        message.error(response.data.msg)
        return Promise.reject(code)
    }
    return response.data
}, function (error) {
    return Promise.reject(error)
})

export default $axios

/**
 * File转换成base64
 */
function convertFileToBase64(file, callback) {
    // 创建一个FileReader对象，它允许Web应用程序异步读取存储在计算机上的文件
    // 也就是file对象
    let reader = new FileReader();
    // 添加一个load事件，load会在加载完毕之后进行触发（也就是readAsDataURL读取完毕后触发）
    reader.addEventListener('load', function (e) {
        const base64Image = e.target.result; // 相当于reader.result 获取文件的Base64
        // 回收内存
        callback && callback(base64Image, file.name); // 调用callback压缩
        reader = null;
    });

    // readAsDataURL方法读取指定的file或blob对象
    reader.readAsDataURL(file);
}

/**
 * base64转换成File
 */
function convertBase64ToFile(base64, callback) {
    // 将base64的数据部分提取出来
    const parts = base64.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);

    // 将原始数据转换为Uint8Array
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }

    // 使用Blob对象创建File对象
    const blob = new Blob([uInt8Array], { type: contentType });
    let file = new File([blob], 'xxx.png', { type: contentType });
    callback(file)
}

/**
 * 压缩图片
 */
function compress(base64Image, callback) {
    let maxW = 950;
    let maxH = 1500;
    const image = new Image(); // 创建image对象 相当于创建a标签
    image.addEventListener('load', function (e) {
        // image加载完成后就会触发 也就是src加载后
        let radio; // 压缩比例
        let needCompress = false; // 是否需要压缩
        // image.naturalWidth/naturalHeight H5新属性 获取源生图片的宽高
        if (image.naturalWidth > maxW) {
            needCompress = true;
            // 获得压缩宽高过后的大小（保证等比例缩放）
            radio = image.naturalWidth / maxW;
            maxH = image.naturalHeight / radio;
        }
        // 同样宽度压缩之后 还要看压缩后的高度是否满足 不满足则继续压缩宽高
        if (image.naturalHeight > maxH) {
            needCompress = true;
            radio = image.naturalHeight / maxH;
            maxW = image.naturalWidth / radio;
        }
        // 不需要压缩
        if (!needCompress) {
            maxW = image.naturalWidth;
            maxH = image.naturalHeight;
        }
        // 第一次压缩完成
        // 接下来使用canvas进行质量压缩
        const canvas = document.createElement('canvas');
        canvas.height = maxH;
        canvas.width = maxW;
        canvas.setAttribute('id', '_compress_');
        // visibility hidden 需要创建的canvas隐藏 而不是不渲染DOM
        canvas.style.visibility = 'hidden';
        document.body.appendChild(canvas);

        const ctx = canvas.getContext('2d');
        // canvas.clearRect() 方法清空给定矩形内的指定像素。(x1，y1，width,height)
        // 防止重新上传覆盖
        ctx.clearRect(0, 0, maxW, maxH);
        // canvas.drawImage() 方法在画布(canvas)上绘制图像、画布或视频。
        // 传入 视频/图片对象 起始点x 起始点y 绘制宽 绘制高
        ctx.drawImage(image, 0, 0, maxW, maxH);
        // 接来下就是压缩canvas 通过API将canvas输出成base64格式

        /**
         * @HTMLCanvasElement.toDataURL(type, encoderOptions);  注意调用这是 Canvas的Dom对象而非ctx
         * @param {String} 可以使用 type 参数其类型， type 图片格式，默认为image/png,图片的分辨率为96dpi。
         * @param {Number}  encoderOptions 可选 指定图片格式是image/jpeg或image/webp的情况下，可以从0到1区间内进行选择图片的质量（1原质量）。如果超出取值方位，使用默认0.92
         * @returns {dataURL}  方法返回一个包含图片展示的 data URI （Base64）
         */
        /* 注意这里是Canvas DOM 节点 而非canvas对象*/
        const compressImage = canvas.toDataURL('image/jpeg', 0.8); // 通常压缩是0.8-0.9
        callback && callback(compressImage); // 压缩完成进行后台传输逻辑
        // 压缩完的图片就已经保存在内存(compressImage)中了
        // 接下来移除canvas元素 调用DOM.remove()
        canvas.remove();
    });
    image.src = base64Image;
    // document.body.appendChild(image) // 挂载
}

/**
 * 处理压缩
 */
export function imgCompress(file, callback) {
    convertFileToBase64(file, (base64Image) => {
        compress(base64Image, (compressedBase64) => {
            convertBase64ToFile(compressedBase64, (compressedFile) => {
                return callback(compressedFile)
            })
        })
    })
}

